import { fallback } from "@tanstack/zod-adapter"
import { z } from "zod"

import { AccountingSubTab } from "../components/AccountsPayable/AccountingSubTabs"

export const accountingSearchParamsSchema = z.object({
  subTab: fallback(z.nativeEnum(AccountingSubTab), AccountingSubTab.AccountsPayable),
})

export type AccountingSearchParams = z.infer<typeof accountingSearchParamsSchema>
